import request from "@src/utils/request";

export interface ProductFilters {
  page?: number;
  pageSize?: number;
  search?: string;
  [key: string]: any;
}

export function getProductCategories() {
  return request().get("/api/v1/product-categories/").send();
}

export function getManufacturers() {
  return request().get("/api/v1/manufacturers/").send();
}

export function getSpecies() {
  return request().get("/api/v1/species/").send();
}

export function getLandingPageProductCategories() {
  return request().get("/api/v1/product-categories/landing-page/").send();
}

export function getLandingPageProducts() {
  return request().get("/api/v1/landing-page/").send();
}

export function getProductCategory(productCategoryId: string) {
  return request()
    .get(`/api/v1/product-categories/${productCategoryId}/`)
    .send();
}

export function getProductCategoryProducts(
  productCategoryId: string,
  filters: ProductFilters = {},
) {
  return request()
    .query(filters)
    .get(`/api/v1/product-categories/${productCategoryId}/products/`)
    .send();
}

export function getProductRecommendations(
  type: string,
  filters: ProductFilters = {},
) {
  return request()
    .query({ type, ...filters })
    .get("/api/v1/current-user/product-recommendations/")
    .send();
}

export function getProductDisplay(productId: string) {
  return request().get(`/api/v1/products/${productId}/display/`).send();
}

export function getProductBreadcrumbs(productId: string) {
  return request().get(`/api/v1/products/${productId}/breadcrumbs/`).send();
}

export function getProductPricing(productId: string) {
  return request().get(`/api/v1/products/${productId}/pricing/`).send();
}

export function getPromotedDistributorProducts(
  distributorSlug: string,
  filters: ProductFilters = {},
) {
  return request()
    .query(filters)
    .get(`/api/v1/distributors/${distributorSlug}/promoted-products/`)
    .send();
}

export function getSimilarProducts(
  productId: string,
  filters: ProductFilters = {},
) {
  return request()
    .query(filters)
    .get(`/api/v1/products/${productId}/similar-products/`)
    .send();
}
